<template>
  <div style="padding-bottom: 20px">
    <div class="head">
      <h3>个人信息修改</h3>
    </div>
    <div class="form_area">
      <el-form
        :model="teacherInfo"
        :rules="rules"
        ref="teacherInfo"
        label-width="100px"
      >
        <el-form-item label="头像" prop="avatar">
          <el-upload
            class="uploader"
            action="#"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="(file) => upload(file, 'avatar')"
          >
            <el-image
              class="upload_img"
              v-if="teacherInfo.avatar"
              :src="teacherInfo.avatar"
              fit="cover"
            ></el-image>
            <i v-else class="el-icon-plus"></i>
          </el-upload>

          <el-popover
            placement="top"
            width="390"
            v-model="visible"
            style="display: inline-block"
            ref="popover"
          >
            <div
              class="img-wrap"
              :class="{ active: selectedAvatar == item }"
              v-for="(item, idx) in avatarArr"
              :key="idx"
              @click="selectedAvatar = item"
            >
              <img class="alternative-avatar" :src="item" alt="" />
            </div>
            <div style="text-align: right; margin: 10px 10px 0 0">
              <el-button
                size="mini"
                type="text"
                @click="
                  visible = false;
                  selectedAvatar = '';
                "
                >取消</el-button
              >
              <el-button type="primary" size="mini" @click="handleSelectAvatar"
                >确定</el-button
              >
            </div>
            <div class="avatar-box" slot="reference">
              <p>备选头像</p>
            </div>
          </el-popover>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input
            v-model="teacherInfo.name"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="teacherInfo.sex">
            <el-radio label="MAN">男</el-radio>
            <el-radio label="WOMAN">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="学校名称" prop="schoolId">
          <el-select
            v-model="teacherInfo.schoolId"
            placeholder="请选择学校"
            disabled
          >
            <el-option
              v-for="item in schoolList"
              :key="item.schoolId"
              :label="item.name"
              :value="item.schoolId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input
            v-model="teacherInfo.address"
            placeholder="请输入地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="简介" prop="info">
          <el-input
            v-model="teacherInfo.info"
            type="textarea"
            resize="none"
            :autosize="{ minRows: 2 }"
            placeholder="请输入简介"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-top: 60px">
          <el-button
            class="btn"
            type="primary"
            @click="submitForm('teacherInfo')"
            >确定</el-button
          >
          <el-button class="btn" @click="resetForm('teacherInfo')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { schoolList } from "@/api/login";
import { editUserInfo } from "@/api/user";
import upload from "@/utils/uploadMethod";
import avatarCompact from "@/utils/avatars";
export default {
  props: {
    teacherInfo: Object,
  },
  data() {
    return {
      avatarArr: avatarCompact.avatarArr,
      selectedAvatar: "",
      rules: {
        avatar: {
          required: true,
          message: "请上传头像",
          trigger: "blur",
        },
        name: {
          required: true,
          message: "请输入姓名",
          trigger: "blur",
        },
        sex: {
          required: true,
          message: "请选择性别",
          trigger: "blur",
        },
        schoolId: {
          required: true,
          message: "请选择学校",
          trigger: "blur",
        },
        address: {
          required: true,
          message: "请输入地址",
          trigger: "blur",
        },
        info: {
          required: true,
          message: "请输入简介",
          trigger: "blur",
        },
      },
      schoolList: [],
      visible: false,
    };
  },
  created() {
    this.getSchoolList();
  },
  methods: {
    //   学校列表
    getSchoolList() {
      schoolList().then((res) => {
        if (res.code == 0) {
          this.schoolList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //上传图片
    async upload(file, str) {
      const fileUrl = await upload(file);
      this.teacherInfo[str] = fileUrl;
    },
    handleSelectAvatar() {
      this.teacherInfo.avatar = this.selectedAvatar;
      this.$refs.popover.doClose();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$loading.show();
          editUserInfo(this.teacherInfo).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("修改成功");
              this.resetForm(formName);
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit("back", 0);
    },
  },
};
</script>

<style lang="less" scoped>
.head {
  padding: 30px;
  margin-top: 30px;
  margin-bottom: 20px;
  height: 88px;
  text-align: left;
  background-color: #fff;

  h3 {
    font-size: 20px;
  }
}

.form_area {
  padding: 80px 280px;
  margin: 0 30px;
  text-align: left;
  background-color: #fff;

  .uploader {
    display: inline-block;
    width: 104px;
    height: 104px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    vertical-align: top;
    overflow: hidden;

    &:hover {
      border-color: teal;
    }

    .el-icon-plus {
      font-size: 28px;
      color: #8c939d;
      width: 104px;
      height: 104px;
      line-height: 104px;
      text-align: center;
    }

    .upload_img {
      width: 104px;
      height: 104px;
      display: block;
    }
  }

  .avatar-box {
    margin-left: 20px;
    width: 104px;
    height: 104px;
    line-height: 104px;
    text-align: center;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    &:hover {
      border-color: teal;
    }
  }
  .el-select {
    width: 100%;
  }

  ::v-deep .el-textarea__inner {
    font-family: inherit;
  }
  .btn {
    width: 97px;
    height: 40px;
    border-radius: 4px;
    font-size: 16px;

    &:first-child {
      margin-right: 60px;
    }
  }
}

.img-wrap {
  display: inline-block;
  margin: 5px;
  border: solid 1px transparent;
  cursor: pointer;
  &.active {
    position: relative;
    border-color: teal;
    &::before {
      content: "✔";
      position: absolute;
      top: 0;
      right: 0;
      width: 15px;
      height: 15px;
      line-height: 15px;
      text-align: center;
      background-color: #fff;
      color: teal;
    }
  }
  .alternative-avatar {
    width: 60px;
    height: 60px;
  }
}
</style>